module.exports = __webpack_public_path__ + "static/img/ayo_icon_2.1040134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ayo_icon_2.png
// module id = dPxi
// module chunks = 1